import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { checkSession, redirectToApp } from '../services/auth'

// Informational and legal routes are linked from inside the app and from
// emails, so a signed-in visitor asking for one of them should be able to read
// it instead of being bounced to the dashboard.
const SKIP_REDIRECT_PATHS = [
  '/about',
  '/privacy',
  '/terms',
  '/security',
  '/sub-processors',
  '/pilot-program',
]

// SessionStorage key so the session check runs at most once per browser session
const SESSION_CHECK_KEY = 'nisa-auth-check-done'

/**
 * Check whether the visitor already has an app session and, if so, send them
 * to the app. Failures are swallowed so the marketing site always renders.
 */
export const useAuthRedirect = () => {
  const location = useLocation()

  useEffect(() => {
    const performAuthCheck = async () => {
      if (SKIP_REDIRECT_PATHS.includes(location.pathname)) {
        return
      }

      if (sessionStorage.getItem(SESSION_CHECK_KEY) === 'true') {
        return
      }

      sessionStorage.setItem(SESSION_CHECK_KEY, 'true')

      try {
        const { authenticated } = await checkSession()

        if (authenticated) {
          redirectToApp()
        }
      } catch {
        // Fail open: never block the marketing site on the session check.
      }
    }

    performAuthCheck()
  }, [location.pathname])
}
